import { Col, Modal, Row } from 'antd';
import React, { FC, ReactNode } from 'react';
import styles from './confirmationModal.module.scss';
import COButton from 'shared/components/COButton';
import { ButtonSize } from 'enums/ButtonEnums';
import { modalCloseIcon } from 'shared/components/OrganizationModal';
import WarningIcon from 'assets//ColorIcons/PNG/warning_alert.png';

interface ConfirmationModalProps {
  showModal: boolean;
  onCancel: () => void;
  onConfirm?: () => void;
  confirmationText: string;
  subInfo?: ReactNode;
  confirmButtonText?: string;
  cancelButtonText?: string;
  width?: number;
  confirmationClassName?: string;
  isCancel?: boolean;
}

const ConfirmationModal: FC<ConfirmationModalProps> = props => {
  const {
    onCancel,
    showModal,
    onConfirm,
    confirmationText,
    confirmButtonText,
    cancelButtonText,
    width,
    subInfo,
    confirmationClassName,
    isCancel,
  } = props;

  const confirmationFooter = (
    <Row className={styles.confirmationFooter} gutter={[15, 15]}>
      <Col span={12} className={styles.confirmButton}>
        <COButton
          primary
          size={ButtonSize.LARGE}
          onClick={onConfirm}
          cancelForm={isCancel}>
          {confirmButtonText ?? 'Confirm'}
        </COButton>
      </Col>
      <Col span={12}>
        <COButton secondary onClick={onCancel}>
          {cancelButtonText ?? 'Cancel'}
        </COButton>
      </Col>
    </Row>
  );
  return (
    <Modal
      destroyOnClose={true}
      maskClosable={false}
      centered
      width={width ?? 500}
      footer={confirmationFooter}
      wrapClassName={styles.modalContainer}
      open={showModal}
      className={confirmationClassName}
      closeIcon={modalCloseIcon}
      onCancel={onCancel}>
      <Row className={styles.alertIconContainer}>
        <img src={WarningIcon} />
      </Row>
      <Row className={styles.confirmationContent}>
        <Col span={24}>{confirmationText}</Col>
        <Col span={24} className={styles.subInfoContent}>
          {subInfo}
        </Col>
      </Row>
    </Modal>
  );
};

export default ConfirmationModal;
